module.exports = new __parcel__URL__("csv-icon.a0071194.svg").toString();